import { TabsList, TabsTrigger } from "@component/tabs";
import { useUserProfileContext } from "@context/user_profile";

interface AssessmentTabsNavigationProps {
    className?: string;
}

export default function AssessmentTabsNavigation({
    className,
}: AssessmentTabsNavigationProps) {
    const [isLoadingUserProfile, userInfo] = useUserProfileContext();
    return (
        <TabsList className="flex w-auto mb-8 bg-transparent h-auto p-0 border-b border-gray-200 justify-start rounded-none">
            <TabsTrigger
                value="details"
                className="text-sm bg-transparent border-0 rounded-none pb-3 px-4 data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:border-b-2 data-[state=active]:border-blue-600 data-[state=active]:text-blue-600 hover:text-blue-600 transition-colors"
                style={{
                    paddingTop: "8px",
                    paddingRight: "24px",
                    paddingBottom: "12px",
                    paddingLeft: "24px",
                }}
            >
                Details
            </TabsTrigger>
            {userInfo?.permission !== "member" && (
                <TabsTrigger
                    value="jobs"
                    className="text-sm bg-transparent border-0 rounded-none pb-3 px-4 data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:border-b-2 data-[state=active]:border-blue-600 data-[state=active]:text-blue-600 hover:text-blue-600 transition-colors"
                    style={{
                        paddingTop: "8px",
                        paddingRight: "24px",
                        paddingBottom: "12px",
                        paddingLeft: "24px",
                    }}
                >
                    Jobs
                </TabsTrigger>
            )}
        </TabsList>
    );
}
